<template>
  <div>
    <div class="toolbar">
      <el-select v-model="issueType" clearable placeholder="问题类型" style="width:140px" @change="load">
        <el-option v-for="t in issueTypes" :key="t" :label="t" :value="t" />
      </el-select>
      <el-select v-model="status" clearable placeholder="状态" style="width:140px" @change="load">
        <el-option label="待办" value="PENDING" />
        <el-option label="待处理" value="OPEN" />
        <el-option label="处理中" value="PROCESSING" />
        <el-option label="已关闭" value="CLOSED" />
      </el-select>
      <el-input v-model="keyword" clearable placeholder="单号/描述" style="width:200px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">提交工单</el-button>
    </div>

    <el-table :data="filteredList" border stripe v-loading="loading">
      <el-table-column prop="ticketNo" label="工单号" width="180" show-overflow-tooltip />
      <el-table-column prop="issueType" label="问题类型" width="110" />
      <el-table-column prop="content" label="问题描述" min-width="220" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">{{ statusText(row.status) }}</template>
      </el-table-column>
      <el-table-column prop="createdByName" label="提交人" width="100" />
      <el-table-column prop="createdAt" label="提交时间" width="170" />
      <el-table-column label="操作" width="170" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">{{ row.status === 'CLOSED' ? '查看' : '回复' }}</el-button>
          <el-button v-if="row.status !== 'CLOSED'" type="text" @click="closeTicket(row)">关闭</el-button>
          <el-button v-if="row.status === 'OPEN'" type="text" style="color:#f56c6c" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="提交咨询工单" :visible.sync="createVisible" width="640px" append-to-body @closed="onCreateClosed">
      <el-form :model="createForm" label-width="96px">
        <el-form-item label="问题类型" required>
          <el-select v-model="createForm.issueType" placeholder="请选择" style="width:100%">
            <el-option v-for="t in issueTypes" :key="t" :label="t" :value="t" />
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述" required>
          <el-input v-model="createForm.content" type="textarea" :rows="5" maxlength="2000" show-word-limit placeholder="请描述您遇到的问题" />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="createForm.contactPhone" maxlength="32" placeholder="选填，方便我们联系您" />
        </el-form-item>
        <el-form-item label="附件">
          <el-upload
            action="#"
            :http-request="elUploadHttpRequest"
            :file-list="createFiles"
            :limit="9"
            multiple
            :on-success="onCreateUploadSuccess"
            :on-error="onCreateUploadError"
            :on-remove="onCreateUploadRemove"
            :on-preview="onUploadPreview"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary" plain>上传附件</el-button>
            <div slot="tip" class="hint">支持图片/常见文档，最多 9 个</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="createVisible=false">取消</el-button>
        <el-button type="primary" :loading="creating" @click="submitCreate">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="current && current.status === 'CLOSED' ? '工单详情' : '工单沟通'" :visible.sync="detailVisible" width="760px" append-to-body @closed="onDetailClosed">
      <div v-loading="detailLoading">
        <template v-if="current">
          <div class="ticket-meta">
            <span>{{ current.ticketNo }}</span>
            <span>{{ current.issueType }}</span>
            <span>{{ statusText(current.status) }}</span>
            <span v-if="current.contactPhone">电话 {{ current.contactPhone }}</span>
          </div>

          <div class="message-list">
            <div
              v-for="(msg, idx) in (current.messages || [])"
              :key="msg.id || idx"
              class="message-item"
              :class="msg.senderType === 'OPS' ? 'ops' : 'tenant'"
            >
              <div class="message-head">
                <span class="sender">{{ msg.senderType === 'OPS' ? '平台客服' : (msg.createdByName || '我') }}</span>
                <span class="time">{{ msg.createdAt || '-' }}</span>
              </div>
              <div class="content-box" :class="{ reply: msg.senderType === 'OPS' }">{{ msg.content }}</div>
              <div v-if="(msg.attachments || []).length" class="file-list">
                <a
                  v-for="(a, i) in msg.attachments"
                  :key="a.id || i"
                  class="file-link"
                  :href="a.url"
                  target="_blank"
                  rel="noopener"
                >{{ a.fileName || ('附件' + (i + 1)) }}</a>
              </div>
            </div>
          </div>

          <div v-if="current.status !== 'CLOSED'" class="reply-box">
            <el-divider content-position="left">继续回复</el-divider>
            <el-input v-model="replyForm.content" type="textarea" :rows="4" maxlength="2000" show-word-limit placeholder="补充说明或追问" />
            <el-upload
              action="#"
              :http-request="elUploadHttpRequest"
              :file-list="replyFiles"
              :limit="9"
              multiple
              :on-success="onReplyUploadSuccess"
              :on-error="onReplyUploadError"
              :on-remove="onReplyUploadRemove"
              :on-preview="onUploadPreview"
              :before-upload="beforeUpload"
              style="margin-top:10px"
            >
              <el-button size="small" type="primary" plain>上传附件</el-button>
            </el-upload>
          </div>
          <div v-else class="muted pad">工单已关闭，无法继续回复。</div>
        </template>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible=false">关闭</el-button>
        <el-button
          v-if="current && current.status !== 'CLOSED'"
          type="warning"
          plain
          :loading="closing"
          @click="closeCurrent"
        >关闭工单</el-button>
        <el-button
          v-if="current && current.status !== 'CLOSED'"
          type="primary"
          :loading="replying"
          @click="submitReply"
        >发送回复</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="previewVisible" append-to-body width="auto">
      <img v-if="previewUrl" :src="previewUrl" class="preview-img" alt="预览" />
    </el-dialog>
  </div>
</template>

<script>
import {
  listConsultTickets,
  getConsultTicket,
  createConsultTicket,
  deleteConsultTicket,
  replyConsultTicket,
  closeConsultTicket,
  listConsultIssueTypes
} from '../../api/consult'
import { elUploadHttpRequest } from '../../utils/ossUpload'

export default {
  name: 'HelpConsultTicket',
  data() {
    return {
      list: [],
      loading: false,
      keyword: '',
      status: '',
      issueType: '',
      issueTypes: ['功能咨询', '故障反馈', '账号权限', '套餐账单', '其他'],
      createVisible: false,
      creating: false,
      createForm: { issueType: '', content: '', contactPhone: '' },
      createFiles: [],
      detailVisible: false,
      detailLoading: false,
      replying: false,
      closing: false,
      replyForm: { content: '' },
      replyFiles: [],
      current: null,
      previewVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    filteredList() {
      if (!this.issueType) return this.list
      return this.list.filter(r => r.issueType === this.issueType)
    }
  },
  created() {
    this.loadTypes()
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    statusText(s) {
      return ({ OPEN: '待处理', PROCESSING: '处理中', DONE: '处理中', CLOSED: '已关闭' }[s]) || s || '-'
    },
    async loadTypes() {
      try {
        const res = await listConsultIssueTypes()
        if (res.data && res.data.length) this.issueTypes = res.data
      } catch (e) { /* keep defaults */ }
    },
    async load() {
      this.loading = true
      try {
        const res = await listConsultTickets({
          keyword: this.keyword || undefined,
          status: this.status || undefined
        })
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.createForm = { issueType: '', content: '', contactPhone: '' }
      this.createFiles = []
      this.createVisible = true
    },
    onCreateClosed() {
      this.createFiles = []
    },
    collectIds(fileList) {
      return (fileList || []).map(f => {
        const d = (f.response && f.response.data) || f.response || {}
        return d.id
      }).filter(Boolean)
    },
    onCreateUploadSuccess(res, file, fileList) {
      const data = (res && res.data) || {}
      if (!data.id) {
        this.$message.error((res && res.message) || '上传失败')
        this.createFiles = fileList.filter(f => f.uid !== file.uid)
        return
      }
      file.url = data.url
      file.response = { data }
      this.createFiles = fileList
    },
    onCreateUploadError() {
      this.$message.error('附件上传失败')
    },
    onCreateUploadRemove(file, fileList) {
      this.createFiles = fileList
    },
    beforeUpload(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.error('单个附件请小于 20MB')
        return false
      }
      return true
    },
    onUploadPreview(file) {
      const url = file.url || (file.response && file.response.data && file.response.data.url)
      if (!url) return
      if (/\.(png|jpe?g|gif|webp|bmp)$/i.test(url) || (file.raw && /^image\//.test(file.raw.type))) {
        this.previewUrl = url
        this.previewVisible = true
      } else {
        window.open(url, '_blank')
      }
    },
    async submitCreate() {
      if (!this.createForm.issueType) return this.$message.warning('请选择问题类型')
      if (!this.createForm.content || !this.createForm.content.trim()) {
        return this.$message.warning('请填写问题描述')
      }
      if ((this.createFiles || []).some(f => f.status === 'uploading')) {
        return this.$message.warning('附件上传中，请稍候')
      }
      if ((this.createFiles || []).some(f => f.status === 'fail')) {
        return this.$message.warning('存在上传失败的附件，请移除后重试')
      }
      this.creating = true
      try {
        await createConsultTicket({
          issueType: this.createForm.issueType,
          content: this.createForm.content.trim(),
          contactPhone: this.createForm.contactPhone || undefined,
          attachmentIds: this.collectIds(this.createFiles)
        })
        this.$message.success('已提交')
        this.createVisible = false
        this.load()
      } finally {
        this.creating = false
      }
    },
    async openDetail(row) {
      this.detailVisible = true
      this.detailLoading = true
      this.current = null
      this.replyForm = { content: '' }
      this.replyFiles = []
      try {
        const res = await getConsultTicket(row.id)
        this.current = res.data || {}
      } catch (e) {
        this.detailVisible = false
      } finally {
        this.detailLoading = false
      }
    },
    onDetailClosed() {
      this.current = null
      this.replyForm = { content: '' }
      this.replyFiles = []
    },
    onReplyUploadSuccess(res, file, fileList) {
      const data = (res && res.data) || {}
      if (!data.id) {
        this.$message.error((res && res.message) || '上传失败')
        this.replyFiles = fileList.filter(f => f.uid !== file.uid)
        return
      }
      file.url = data.url
      file.response = { data }
      this.replyFiles = fileList
    },
    onReplyUploadError() {
      this.$message.error('附件上传失败')
    },
    onReplyUploadRemove(file, fileList) {
      this.replyFiles = fileList
    },
    async submitReply() {
      if (!this.current) return
      if (!this.replyForm.content || !this.replyForm.content.trim()) {
        return this.$message.warning('请填写回复内容')
      }
      if ((this.replyFiles || []).some(f => f.status === 'uploading')) {
        return this.$message.warning('附件上传中，请稍候')
      }
      if ((this.replyFiles || []).some(f => f.status === 'fail')) {
        return this.$message.warning('存在上传失败的附件，请移除后重试')
      }
      this.replying = true
      try {
        const res = await replyConsultTicket(this.current.id, {
          content: this.replyForm.content.trim(),
          attachmentIds: this.collectIds(this.replyFiles)
        })
        this.current = res.data || {}
        this.replyForm = { content: '' }
        this.replyFiles = []
        this.$message.success('已发送')
        this.load()
      } finally {
        this.replying = false
      }
    },
    async closeTicket(row) {
      try {
        await this.$confirm('确定关闭该工单？关闭后将无法继续回复。', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      const fromDetail = this.current && this.current.id === row.id
      if (fromDetail) this.closing = true
      try {
        const res = await closeConsultTicket(row.id)
        this.$message.success('工单已关闭')
        if (fromDetail) {
          this.current = res.data || { ...this.current, status: 'CLOSED' }
          this.replyForm = { content: '' }
          this.replyFiles = []
        }
        this.load()
      } finally {
        if (fromDetail) this.closing = false
      }
    },
    async closeCurrent() {
      if (!this.current) return
      await this.closeTicket(this.current)
    },
    async remove(row) {
      try {
        await this.$confirm('确定删除该待处理工单？', '提示', { type: 'warning' })
      } catch (e) {
        return
      }
      await deleteConsultTicket(row.id)
      this.$message.success('已删除')
      if (this.current && this.current.id === row.id) this.detailVisible = false
      this.load()
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
.ticket-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  color: #64748b;
  font-size: 13px;
}
.message-list { display: flex; flex-direction: column; gap: 14px; max-height: 420px; overflow-y: auto; padding-right: 4px; }
.message-item.tenant .sender { color: #0f766e; }
.message-item.ops .sender { color: #2563eb; }
.message-head { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 6px; font-size: 13px; }
.message-head .time { color: #94a3b8; }
.reply-box { margin-top: 8px; }
.content-box {
  white-space: pre-wrap;
  line-height: 1.6;
  color: #334155;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
}
.content-box.reply { background: #eff6ff; border-color: #bfdbfe; }
.file-list { display: flex; flex-direction: column; gap: 6px; }
.file-link { color: #2563eb; font-size: 13px; }
.muted { color: #94a3b8; font-size: 13px; }
.pad { padding: 8px 0 16px; }
.hint { margin-top: 6px; color: #94a3b8; font-size: 12px; }
.preview-img { max-width: 80vw; max-height: 80vh; display: block; }
</style>
